var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "profile [#1335]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[1.9]-Competitor-Pricing---Showing-hover-after-price-has-been-edited-by-user-on-both-pricing",
    transform: "translate(-416.000000, -1094.000000)",
    fill: "#39C258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(349.000000, 899.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gas-Buddy",
    transform: "translate(59.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Competitor-Pricing-/-Gas-Buddy",
    transform: "translate(8.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,8 C6.2352,8 4.8,6.5648 4.8,4.8 C4.8,3.0352 6.2352,1.6 8,1.6 C9.7648,1.6 11.2,3.0352 11.2,4.8 C11.2,6.5648 9.7648,8 8,8 M11.0064,8.5384 C12.0992,7.6592 12.8,6.312 12.8,4.8 C12.8,2.1488 10.6512,0 8,0 C5.3488,0 3.2,2.1488 3.2,4.8 C3.2,6.312 3.9008,7.6592 4.9936,8.5384 C2.0664,9.6384 0,12.356 0,16 L1.6,16 C1.6,12 4.4712,9.6 8,9.6 C11.5288,9.6 14.4,12 14.4,16 L16,16 C16,12.356 13.9336,9.6384 11.0064,8.5384",
    id: "profile-[#1335]"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.0b367930.svg";
export { ForwardRef as ReactComponent };